var _polygon, _g, _g2, _g3, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaslCross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 400",
    style: {
      enableBackground: "new 0 0 1366 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9,397.4 1357,84.5 1357,2.6 9,315.5 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "225,245.8 249.8,147.1 271.2,235.1 339,219.3 295.3,33.3 206.2,33.3 150,263.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.8,264.4 99.1,33.3 12.4,33.3 75.1,280.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.7,194.6 487.8,33.3 400.5,33.3 364.6,213.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.2,313.7 302.9,366.1 401,366.1 422.7,282.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.9,359 96.7,366.1 194.8,366.1 202.9,333.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "666.6,143.6 673.5,122.9 679.5,140.6 753.5,123.4 720.9,33.3 627.1,33.3 579.9,163.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "705.6,217.6 714.8,244.7 632.8,244.7 636.5,233.6 547.1,254.4 506.7,366.1 591.5,366.1 611.5,307.3 735.6,307.3  755.5,366.1 841.3,366.1 781.3,200  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1115.3,128.1c-0.1-1.9-0.2-3.7-0.4-5.5l-23.8,5.5H1115.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070,189.3c-13.4-6.6-30.9-13.6-52.4-20.9c-15.7-5.1-28.3-9.9-37.9-14.4l-97.1,22.5c0.4,0.6,0.9,1.3,1.3,1.9 c9.8,13,21.5,22.8,35.1,29.4c13.6,6.6,31.1,13.3,52.6,19.9c14.8,4.4,26.3,8.4,34.4,11.8c8.1,3.5,14.8,7.9,20.4,13.3 c5.5,5.4,8.3,12.2,8.3,20.4c0,9.8-3.5,17.5-10.4,23c-7,5.5-16.4,8.3-28.4,8.3c-11.7,0-21.2-3.2-28.4-9.7 c-7.3-6.5-11.5-15.9-12.8-28.2h-86.3c0.6,21.8,6.7,40.5,18.2,55.9c11.5,15.5,26.9,27.2,46.2,35.1c19.3,7.9,41.1,11.8,65.4,11.8 c25,0,46.6-4.6,64.9-13.7c18.3-9.2,32.3-21.5,41.9-37c9.6-15.5,14.5-32.7,14.5-51.7c0-19.9-4.9-36.2-14.7-48.8 C1095.1,205.5,1083.4,195.9,1070,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.8,49.6c-21.4-14-48.4-21-81.2-21c-36,0-65.3,8.8-87.7,26.3c-14,10.9-23.6,24.5-28.9,40.6L1071.8,49.6z"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1250.4,91.2 1169.3,110 1169.3,366.1 1356.5,366.1 1356.5,303.5 1250.4,303.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaslCross);
export default __webpack_public_path__ + "static/media/wasl-cross.baec4d28f7640a414b8d8968f506c511.svg";
export { ForwardRef as ReactComponent };